import React from 'react'
import { AiFillDelete, AiFillEdit } from 'react-icons/ai'
import ProductLabel from '../product/ProductLabel'
import { translateStatus } from '../../utils/translator'
import { FaCheck, FaTruck, FaTruckLoading, FaUndo } from 'react-icons/fa'
import { IoIosSend } from 'react-icons/io'

const PlanCard = (props) => {

    const { onClickEdit, onClickTrash, plan, onClickShipment, onClickSend, onClickNavShipmentPage, onClickTakeBack, onClickComplete, disabled } = props

    return (
        <div className='border shadow-md rounded-lg p-4 text-sm mb-5 flex flex-col justify-between'>
            <div className='relative'>
                <div className='flex justify-end gap-x-3 absolute right-3'>
                    {
                        !disabled &&
                        <>
                            {
                                plan.status === 'IN_PROGRESS' &&
                                <>
                                    {/* <FaTruckLoading
                                        onClick={onClickNavShipmentPage}
                                    /> */}
                                    <FaTruck
                                        onClick={onClickShipment}
                                    />
                                </>
                            }
                            {
                                plan.status === 'PENDING' &&
                                <FaTruck
                                    onClick={onClickShipment}
                                />
                            }


                            <AiFillEdit
                                onClick={onClickEdit}
                            />
                            <AiFillDelete
                                onClick={onClickTrash}
                            />

                        </>

                    }
                    <FaTruckLoading
                        onClick={onClickNavShipmentPage}
                    />
                    <FaTruck
                        onClick={onClickShipment}
                    />
                </div>
                <label className='block mb-3 text-sm'>İşlem : {plan.operation.name}</label>
                <div className='mb-3'>
                    <label className='block border-b mb-3'>Gidecek Ürünler</label>
                    {
                        plan.inputDetails?.map((detail, index) => (
                            <div key={index} className='grid grid-cols-12 border-b mb-2 bg-purple-100 p-1 rounded-md'>
                                <div className='col-span-1'>
                                    <label>{index + 1}. </label>
                                </div>
                                <div className='col-span-9'>
                                    <label><ProductLabel state={detail.product} /> </label>
                                </div>
                                <div className='col-span-2 text-center'>
                                    <label>{detail.quantity} m</label>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className='mb-3'>
                    <label className='block border-b mb-3'>Beklenen Ürün</label>
                    <div className='grid grid-cols-12 border-b mb-2 bg-purple-100 p-1 rounded-md'>
                        <div className='col-span-1'>

                        </div>
                        <div className='col-span-9'>
                            <label><ProductLabel state={plan.outputDetail.product} /> </label>
                        </div>
                        <div className='col-span-2 text-center'>
                            <label>{plan.outputDetail.quantity} m</label>
                        </div>
                    </div>
                </div>
                <div className='mb-3'>
                    <label className='block border-b mb-3'>Açıklama</label>
                    <label>{plan.description} </label>
                </div>

            </div>
            <div className='mb-3 flex justify-between'>
                <div>
                    Durum : {plan.status ? `${translateStatus(plan.status)}` : 'Yeni'}
                </div>
                <div className='flex gap-x-3'>
                    {
                        !disabled &&
                        <>
                            {
                                plan.status === 'PENDING' &&
                                <IoIosSend
                                    onClick={onClickSend}
                                />
                            }
                            {
                                plan.status === 'IN_PROGRESS' &&
                                <>
                                    <FaUndo
                                        onClick={onClickTakeBack}
                                    />
                                    <FaCheck
                                        onClick={onClickComplete}
                                    />
                                </>
                            }
                            {
                                plan.status === 'COMPLETED' &&
                                <FaUndo
                                    onClick={onClickSend}
                                />
                            }
                        </>
                    }

                </div>

            </div>
        </div>
    )
}

export default PlanCard